module.exports = __webpack_public_path__ + "img/9 filters B-06.01f81a2d.png";